import { render } from "./LaunchButton.vue?vue&type=template&id=3c496bee&scoped=true"
import script from "./LaunchButton.vue?vue&type=script&lang=js"
export * from "./LaunchButton.vue?vue&type=script&lang=js"

import "./LaunchButton.vue?vue&type=style&index=0&id=3c496bee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c496bee"]])

export default __exports__